import type { IntlService } from 'ember-intl';
import type { TSafetyStockFormula } from '../types/planning-settings';

export const SafetyStockFormulas: Record<TSafetyStockFormula, string> = {
  FIXED: 'safetyStockFormulas.FIXED',
  SAFETY_DAYS: 'safetyStockFormulas.SAFETY_DAYS',
  AVG_MAX: 'safetyStockFormulas.AVG_MAX',
  GAUSS_DEMAND: 'safetyStockFormulas.GAUSS_DEMAND',
  GAUSS_LT: 'safetyStockFormulas.GAUSS_LT',
  GAUSS_DEMAND_LT_IND: 'safetyStockFormulas.GAUSS_DEMAND_LT_IND',
  GAUSS_DEMAND_LT_DEP: 'safetyStockFormulas.GAUSS_DEMAND_LT_DEP'
};

export const SafetyStockFormulaOptions = Object.keys(SafetyStockFormulas).map(
  (key) => {
    return { key, label: SafetyStockFormulas[key as TSafetyStockFormula] };
  }
);

export const SafetyStockFormulaArray: TSafetyStockFormula[] = Object.keys(
  SafetyStockFormulas
) as TSafetyStockFormula[];

export const SafetyStockFormulaWithADU: TSafetyStockFormula[] = [
  'SAFETY_DAYS',
  'AVG_MAX',
  'GAUSS_DEMAND_LT_DEP',
  'GAUSS_DEMAND_LT_IND',
  'GAUSS_LT'
];

export const translatedOptions = (intl: IntlService) =>
  SafetyStockFormulaOptions.map((o) => ({ ...o, label: intl.t(o.label) }));

export default SafetyStockFormulas;
